import { Injectable, inject } from '@angular/core';
import { GoogleConsentService } from 'src/app/ecommerce/shared/services/cookies/google-consent.service';
import { GoogleMapsLoaderService } from 'src/app/ecommerce/shared/services/cookies/google-maps-loader.service';

@Injectable({
    providedIn: 'root',
})
export class AppInitService {
    private readonly googleConsentService = inject(GoogleConsentService);
    private readonly googleMapsLoaderService = inject(GoogleMapsLoaderService);

    init(): Promise<boolean> {
        this.googleConsentService.restoreFromStorage();
        this.googleMapsLoaderService.loadIfAllowed();

        return Promise.resolve(true);
    }
}
